import { Feedback, FeedbackInput } from '@@types'
import { gql, useMutation } from '@apollo/client'

type SaveFeedbackData = {
  saveFeedback: Feedback
}

type SaveFeedbackVariables = {
  feedbackInfo: FeedbackInput
}

export const GQL_MUTATION_SAVE_FEEDBACK = gql`
  mutation saveFeedback($feedbackInfo: FeedbackInput!) {
    saveFeedback(
      feedbackInfo: $feedbackInfo
    ) {
      id
    }
  }
`

export const useSaveFeedback = () =>
  useMutation<SaveFeedbackData, SaveFeedbackVariables>(GQL_MUTATION_SAVE_FEEDBACK)
